import { db } from '../../src/main'

export function leaveMessage (message) {
  let stamp = Date.now()
  let time = new Date(stamp).toLocaleString()
  // Add four random digit to the stamp tail
  let stampStr = String(stamp)
  let tail = String(Math.floor(Math.random() * 1000))
  while (tail.length < 4) {
    tail = '0' + tail
  }
  message.stamp = stampStr + tail

  message.time = time
  message.status = 'Unread'
  return new Promise((resolve, reject) => {
    return db.collection('message').doc(message.stamp).set(message).then(doc => {
      // console.log('message sent')
      resolve('message sent')
    }).catch(err => {
      // console.log(err)
      reject(err)
    })
  })
}

export function changeStatus (stamp, status) {
  return new Promise((resolve, reject) => {
    return db.collection('message').doc(stamp).update({ status: status }).then(doc => {
      // console.log('message updated')
      resolve('message updated')
    }).catch(err => {
      // console.log(err)
      reject(err)
    })
  })
}
